import { TabsDataType } from '@/core/components/Tabs/Tabs.types';

import { Report } from '@/features/Reports/interfaces';

export enum ReportSectionId {
  DETAILS = 'details',
  ARTICLES = 'articles',
  MEDIA = 'media',
}

export type ReportSectionTab = TabsDataType<ReportSectionId>;

export type ReportSectionsBaseProps = {
  report: Report;
  country: string;
  categories: Array<string>;
  locationAddress: string;
  eventDate: string | null;
  eventLocalTime?: string | null;
};
